export const GET_PRICE = "GET_PRICE"
export const GET_PRICE_SUCCESSFUL = "GET_PRICE_SUCCESSFUL"
export const GET_PRICE_FAILED = "GET_PRICE_FAILED"


export const VERIFY_WALLET = "VERIFY_WALLET"
export const VERIFY_WALLET_SUCCESSFUL = "VERIFY_WALLET_SUCCESSFUL"
export const VERIFY_WALLET_FAILED = "VERIFY_WALLET_FAILED"
